import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../core/Error.js";
import { isNone as n, isSome as i } from "../../core/maybe.js";
import { getDeepValue as t, setDeepValue as r } from "../../core/object.js";
import { validateDomainValue as l, getDomainRange as o, DomainValidationError as s } from "./domainUtils.js";
import { loadArcade as a } from "../../support/arcadeOnDemand.js";
var u = ["field", "field2", "field3", "normalizationField", "rotationInfo.field", "proportionalSymbolInfo.field", "proportionalSymbolInfo.normalizationField", "colorInfo.field", "colorInfo.normalizationField"],
    f = ["field", "normalizationField"];

function d(e, n) {
  if (null != e && null != n) {
    var _iterator = _createForOfIteratorHelper(Array.isArray(e) ? e : [e]),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _i = _step.value;

        if (c(u, _i, n), "visualVariables" in _i && _i.visualVariables) {
          var _iterator2 = _createForOfIteratorHelper(_i.visualVariables),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _e = _step2.value;
              c(f, _e, n);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
}

function c(e, n, i) {
  if (e) {
    var _iterator3 = _createForOfIteratorHelper(e),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _l = _step3.value;

        var _e2 = t(_l, n),
            _o = _e2 && "function" != typeof _e2 && i.get(_e2);

        _o && r(_l, _o.name, n);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
}

function m(e, n) {
  if (null != e && null != n && n.fields.length) if ("startField" in e) {
    var _i2 = n.get(e.startField),
        _t = n.get(e.endField);

    e.startField = _i2 && _i2.name || null, e.endField = _t && _t.name || null;
  } else {
    var _i3 = n.get(e.startTimeField),
        _t2 = n.get(e.endTimeField);

    e.startTimeField = _i3 && _i3.name || null, e.endTimeField = _t2 && _t2.name || null;
  }
}

var p = new Set();

function y(e, n) {
  return e && n ? (p.clear(), g(p, e, n), Array.from(p).sort()) : [];
}

function g(e, n, i) {
  var t;
  if (i) if (null != n && null != (t = n.fields) && t.length) {
    if (i.includes("*")) {
      var _iterator4 = _createForOfIteratorHelper(n.fields),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _r = _step4.value.name;
          e.add(_r);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    } else {
      var _iterator5 = _createForOfIteratorHelper(i),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _r2 = _step5.value;
          F(e, n, _r2);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  } else {
    if (i.includes("*")) return e.clear(), void e.add("*");

    var _iterator6 = _createForOfIteratorHelper(i),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var _n = _step6.value;
        e.add(_n);
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  }
}

function F(e, n, i) {
  if ("string" == typeof i) if (n) {
    var _t3 = n.get(i);

    _t3 && e.add(_t3.name);
  } else e.add(i);
}

function I(e, i) {
  return n(i) || n(e) ? [] : i.includes("*") ? e.fields.map(function (e) {
    return e.name;
  }) : i;
}

function x(e, n) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  if (!n || !e) return [];
  if (n.includes("*")) return ["*"];
  var t = y(e, n);
  return t.length / e.fields.length >= i ? ["*"] : t;
}

function b(_x, _x2, _x3) {
  return _b.apply(this, arguments);
}

function _b() {
  _b = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, n, i) {
    var t, _yield$a, r, l, _iterator11, _step11, _o3;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (i) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.next = 4;
            return a();

          case 4:
            _yield$a = _context.sent;
            r = _yield$a.arcadeUtils;
            l = r.extractFieldNames(i, null == n || null == (t = n.fields) ? void 0 : t.map(function (e) {
              return e.name;
            }));
            _iterator11 = _createForOfIteratorHelper(l);

            try {
              for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                _o3 = _step11.value;
                F(e, n, _o3);
              }
            } catch (err) {
              _iterator11.e(err);
            } finally {
              _iterator11.f();
            }

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _b.apply(this, arguments);
}

function T(_x4, _x5, _x6) {
  return _T.apply(this, arguments);
}

function _T() {
  _T = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(n, i, t) {
    var _r3;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(t && "1=1" !== t)) {
              _context2.next = 7;
              break;
            }

            _context2.next = 3;
            return import("../../core/sql/WhereClause.js");

          case 3:
            _r3 = _context2.sent.WhereClause.create(t, i);

            if (_r3.isStandardized) {
              _context2.next = 6;
              break;
            }

            throw new e("fieldUtils:collectFilterFields", "Where clause is not standardized");

          case 6:
            g(n, i, _r3.fieldNames);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _T.apply(this, arguments);
}

function h(_ref) {
  var e = _ref.displayField,
      n = _ref.fields;
  return e || (n && n.length ? w(n, "name-or-title") || w(n, "unique-identifier") || w(n, "type-or-category") || v(n) : null);
}

function v(e) {
  var _iterator7 = _createForOfIteratorHelper(e),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var _n2 = _step7.value;
      if (!_n2 || !_n2.name) continue;

      var _e3 = _n2.name.toLowerCase();

      if (_e3.indexOf("name") > -1 || _e3.indexOf("title") > -1) return _n2.name;
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  return null;
}

function w(e, n) {
  var _iterator8 = _createForOfIteratorHelper(e),
      _step8;

  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var _i4 = _step8.value;
      if (_i4 && _i4.valueType && _i4.valueType === n) return _i4.name;
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }

  return null;
}

function S(_x7) {
  return _S.apply(this, arguments);
}

function _S() {
  _S = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
    var n;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (e) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", []);

          case 2:
            n = new Set();
            _context3.next = 5;
            return A(n, e);

          case 5:
            return _context3.abrupt("return", Array.from(n).sort());

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _S.apply(this, arguments);
}

function A(_x8, _x9) {
  return _A.apply(this, arguments);
}

function _A() {
  _A = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e, n) {
    var i;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (n) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return");

          case 2:
            i = t("elevationInfo.featureExpressionInfo", n);
            return _context4.abrupt("return", i ? i.collectRequiredFields(e, n.fieldsIndex) : void 0);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _A.apply(this, arguments);
}

function E(_x10, _x11, _x12) {
  return _E.apply(this, arguments);
}

function _E() {
  _E = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e, n, i) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            i.outStatistic.onStatisticValueExpression ? b(e, n, i.outStatistic.onStatisticValueExpression) : e.add(i.outStatistic.onStatisticField);

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _E.apply(this, arguments);
}

function N(_x13, _x14, _x15) {
  return _N.apply(this, arguments);
}

function _N() {
  _N = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e, n, i) {
    var t, r, l, _t5, _iterator12, _step12, _i5;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!(!n || !i || "cluster" !== i.type)) {
              _context6.next = 2;
              break;
            }

            return _context6.abrupt("return");

          case 2:
            l = [];

            if (null != (t = i.popupTemplate) && t.expressionInfos && l.push.apply(l, _toConsumableArray(i.popupTemplate.expressionInfos.map(function (i) {
              return b(e, n.fieldsIndex, i.expression);
            }))), Array.isArray(null == (r = i.popupTemplate) ? void 0 : r.content)) {
              _t5 = i.popupTemplate.content;
              _iterator12 = _createForOfIteratorHelper(_t5);

              try {
                for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                  _i5 = _step12.value;
                  "expression" === _i5.type && _i5.expressionInfo && l.push(b(e, n.fieldsIndex, _i5.expressionInfo.expression));
                }
              } catch (err) {
                _iterator12.e(err);
              } finally {
                _iterator12.f();
              }
            }

            i.fields && l.push.apply(l, _toConsumableArray(i.fields.map(function (i) {
              return E(e, n.fieldsIndex, i);
            })));
            _context6.next = 7;
            return Promise.all(l);

          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _N.apply(this, arguments);
}

function V(_x16, _x17, _x18) {
  return _V.apply(this, arguments);
}

function _V() {
  _V = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e, n, t) {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.t0 = n;

            if (!_context7.t0) {
              _context7.next = 8;
              break;
            }

            n.timeInfo && i(t) && t.timeExtent && g(e, n.fieldsIndex, [n.timeInfo.startField, n.timeInfo.endField]);
            n.floorInfo && g(e, n.fieldsIndex, [n.floorInfo.floorField]);
            _context7.t1 = i(t) && i(t.where);

            if (!_context7.t1) {
              _context7.next = 8;
              break;
            }

            _context7.next = 8;
            return T(e, n.fieldsIndex, t.where);

          case 8:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _V.apply(this, arguments);
}

function _(_x19, _x20, _x21) {
  return _2.apply(this, arguments);
}

function _2() {
  _2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e, n, i) {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.t0 = n && i;

            if (!_context8.t0) {
              _context8.next = 4;
              break;
            }

            _context8.next = 4;
            return Promise.all(i.map(function (i) {
              return D(e, n, i);
            }));

          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _2.apply(this, arguments);
}

function D(_x22, _x23, _x24) {
  return _D.apply(this, arguments);
}

function _D() {
  _D = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(e, n, i) {
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.t0 = n && i;

            if (!_context9.t0) {
              _context9.next = 8;
              break;
            }

            if (!i.valueExpression) {
              _context9.next = 7;
              break;
            }

            _context9.next = 5;
            return b(e, n.fieldsIndex, i.valueExpression);

          case 5:
            _context9.next = 8;
            break;

          case 7:
            i.field && F(e, n.fieldsIndex, i.field);

          case 8:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _D.apply(this, arguments);
}

function $(_x25) {
  return _$.apply(this, arguments);
}

function _$() {
  _$ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(e) {
    var n;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            if (e) {
              _context10.next = 2;
              break;
            }

            return _context10.abrupt("return", []);

          case 2:
            n = "timeInfo" in e && e.timeInfo;
            return _context10.abrupt("return", n ? y(e.fieldsIndex, [e.trackIdField, n.startField, n.endField]) : []);

          case 4:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _$.apply(this, arguments);
}

function O(e) {
  if (!e) return [];
  var n = "editFieldsInfo" in e && e.editFieldsInfo;
  return n ? y(e.fieldsIndex, [n && n.creatorField, n && n.creationDateField, n && n.editorField, n && n.editDateField]) : [];
}

function L(e) {
  if (!e) return [];
  var n = e.geometryFieldsInfo;
  return n ? y(e.fieldsIndex, [n.shapeAreaField, n.shapeLengthField]) : [];
}

function U(_x26) {
  return _U.apply(this, arguments);
}

function _U() {
  _U = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(e) {
    var n;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (e) {
              _context11.next = 2;
              break;
            }

            return _context11.abrupt("return", []);

          case 2:
            n = new Set();
            _context11.next = 5;
            return j(n, e);

          case 5:
            return _context11.abrupt("return", Array.from(n).sort());

          case 6:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _U.apply(this, arguments);
}

function j(_x27, _x28) {
  return _j.apply(this, arguments);
}

function _j() {
  _j = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(e, n) {
    var i, t;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            i = n.labelingInfo, t = n.fieldsIndex;
            _context12.t0 = i && i.length;

            if (!_context12.t0) {
              _context12.next = 5;
              break;
            }

            _context12.next = 5;
            return Promise.all(i.map(function (n) {
              return z(e, t, n);
            }));

          case 5:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _j.apply(this, arguments);
}

function z(_x29, _x30, _x31) {
  return _z.apply(this, arguments);
}

function _z() {
  _z = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(e, n, i) {
    var t, r, _i6;

    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            if (i) {
              _context13.next = 2;
              break;
            }

            return _context13.abrupt("return");

          case 2:
            t = i.getLabelExpression(), r = i.where;

            if (!("arcade" === t.type)) {
              _context13.next = 8;
              break;
            }

            _context13.next = 6;
            return b(e, n, t.expression);

          case 6:
            _context13.next = 10;
            break;

          case 8:
            _i6 = t.expression.match(/{[^}]*}/g);
            _i6 && _i6.forEach(function (i) {
              F(e, n, i.slice(1, -1));
            });

          case 10:
            _context13.next = 12;
            return T(e, n, r);

          case 12:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _z.apply(this, arguments);
}

function P(e) {
  var n = e.defaultValue;
  return void 0 !== n && Y(e, n) ? n : e.nullable ? null : void 0;
}

function k(e) {
  return "number" == typeof e && !isNaN(e) && isFinite(e);
}

function R(e) {
  return null === e || k(e);
}

var C = "isInteger" in Number ? Number.isInteger : function (e) {
  return "number" == typeof e && isFinite(e) && Math.floor(e) === e;
};

function G(e) {
  return null === e || C(e);
}

function q(e) {
  return null != e && "string" == typeof e;
}

function M(e) {
  return null === e || q(e);
}

function W() {
  return !0;
}

function Y(e, n) {
  var i;

  switch (e.type) {
    case "date":
    case "integer":
    case "long":
    case "small-integer":
    case "esriFieldTypeDate":
    case "esriFieldTypeInteger":
    case "esriFieldTypeLong":
    case "esriFieldTypeSmallInteger":
      i = e.nullable ? G : C;
      break;

    case "double":
    case "single":
    case "esriFieldTypeSingle":
    case "esriFieldTypeDouble":
      i = e.nullable ? R : k;
      break;

    case "string":
    case "esriFieldTypeString":
      i = e.nullable ? M : q;
      break;

    default:
      i = W;
  }

  return 1 === arguments.length ? i : i(n);
}

var J = ["integer", "small-integer", "single", "double"],
    X = new Set([].concat(J, ["esriFieldTypeInteger", "esriFieldTypeSmallInteger", "esriFieldTypeSingle", "esriFieldTypeDouble"]));

function B(e) {
  return null != e && X.has(e.type);
}

function H(e) {
  return null != e && ("string" === e.type || "esriFieldTypeString" === e.type);
}

function K(e) {
  return null != e && ("date" === e.type || "esriFieldTypeDate" === e.type);
}

function Q(e, n) {
  return null === ie(e, n);
}

var Z, ee;

function ne(e) {
  return null == e || "number" == typeof e && isNaN(e) ? null : e;
}

function ie(e, n) {
  return e.nullable && null === n ? null : B(e) && !te(e.type, Number(n)) ? Z.OUT_OF_RANGE : Y(e, n) ? e.domain ? l(e.domain, n) : null : ee.INVALID_TYPE;
}

function te(e, n) {
  var i = "string" == typeof e ? le(e) : e;
  return !!i && (i.isInteger ? C(n) && n >= i.min && n <= i.max : n >= i.min && n <= i.max);
}

function re(e) {
  var n = o(e.domain);
  return n || (B(e) ? le(e.type) : void 0);
}

function le(e) {
  switch (e) {
    case "esriFieldTypeSmallInteger":
    case "small-integer":
      return se;

    case "esriFieldTypeInteger":
    case "integer":
      return ae;

    case "esriFieldTypeSingle":
    case "single":
      return ue;

    case "esriFieldTypeDouble":
    case "double":
      return fe;
  }
}

function oe(e) {
  if (!k(e)) return null;

  if (C(e)) {
    if (e >= se.min && e <= se.max) return "esriFieldTypeSmallInteger";
    if (e >= ae.min && e <= ae.max) return "esriFieldTypeInteger";
  }

  return e >= ue.min && e <= ue.max ? "esriFieldTypeSingle" : "esriFieldTypeDouble";
}

!function (e) {
  e.OUT_OF_RANGE = "numeric-range-validation-error::out-of-range";
}(Z || (Z = {})), function (e) {
  e.INVALID_TYPE = "type-validation-error::invalid-type";
}(ee || (ee = {}));
var se = {
  min: -32768,
  max: 32767,
  isInteger: !0
},
    ae = {
  min: -2147483648,
  max: 2147483647,
  isInteger: !0
},
    ue = {
  min: -34e37,
  max: 12e37,
  isInteger: !1
},
    fe = {
  min: -Number.MAX_VALUE,
  max: Number.MAX_VALUE,
  isInteger: !1
};

function de(e, n, i) {
  switch (e) {
    case s.INVALID_CODED_VALUE:
      return "Value ".concat(i, " is not in the coded domain - field: ").concat(n.name, ", domain: ").concat(JSON.stringify(n.domain));

    case s.VALUE_OUT_OF_RANGE:
      return "Value ".concat(i, " is out of the range of valid values - field: ").concat(n.name, ", domain: ").concat(JSON.stringify(n.domain));

    case ee.INVALID_TYPE:
      return "Value ".concat(i, " is not a valid value for the field type - field: ").concat(n.name, ", type: ").concat(n.type, ", nullable: ").concat(n.nullable);

    case Z.OUT_OF_RANGE:
      {
        var _le = le(n.type),
            _e4 = _le.min,
            _t4 = _le.max;

        return "Value ".concat(i, " is out of range for the number type - field: ").concat(n.name, ", type: ").concat(n.type, ", value range is ").concat(_e4, " to ").concat(_t4);
      }
  }
}

function ce(e, n) {
  return !me(e, n, null);
}

function me(e, n, t) {
  if (!n || !n.attributes || !e) {
    if (i(t)) {
      var _iterator9 = _createForOfIteratorHelper(e),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _n3 = _step9.value;
          t.add(_n3);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }

    return !0;
  }

  var r = n.attributes;
  var l = !1;

  var _iterator10 = _createForOfIteratorHelper(e),
      _step10;

  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var _o2 = _step10.value;

      if (!(_o2 in r)) {
        if (l = !0, !i(t)) break;
        t.add(_o2);
      }
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }

  return l;
}

function pe(_x32, _x33) {
  return _pe.apply(this, arguments);
}

function _pe() {
  _pe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(e, n) {
    var i, _iterator13, _step13, _t6;

    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            i = new Set();
            _iterator13 = _createForOfIteratorHelper(n);
            _context14.prev = 2;

            _iterator13.s();

          case 4:
            if ((_step13 = _iterator13.n()).done) {
              _context14.next = 10;
              break;
            }

            _t6 = _step13.value;
            _context14.next = 8;
            return b(i, e.fieldsIndex, _t6);

          case 8:
            _context14.next = 4;
            break;

          case 10:
            _context14.next = 15;
            break;

          case 12:
            _context14.prev = 12;
            _context14.t0 = _context14["catch"](2);

            _iterator13.e(_context14.t0);

          case 15:
            _context14.prev = 15;

            _iterator13.f();

            return _context14.finish(15);

          case 18:
            return _context14.abrupt("return", Array.from(i).sort());

          case 19:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[2, 12, 15, 18]]);
  }));
  return _pe.apply(this, arguments);
}

export { Z as NumericRangeValidationError, ee as TypeValidationError, b as collectArcadeFieldNames, A as collectElevationFields, N as collectFeatureReductionFields, F as collectField, g as collectFields, V as collectFilterFields, j as collectLabelingFields, _ as collectOrderByInfos, fe as doubleRange, ce as featureHasFields, y as fixFields, d as fixRendererFields, m as fixTimeInfoFields, h as getDisplayFieldName, S as getElevationFields, pe as getExpressionFields, O as getFeatureEditFields, L as getFeatureGeometryFields, P as getFieldDefaultValue, re as getFieldRange, U as getLabelingFields, oe as getNumericTypeForValue, $ as getTimeFields, ae as integerRange, K as isDateField, te as isNumberInRange, B as isNumericField, H as isStringField, Q as isValidFieldValue, Y as isValueMatchingFieldType, J as numericTypes, x as packFields, me as populateMissingFields, u as rendererFields, ne as sanitizeNullFieldValue, ue as singleRange, se as smallIntegerRange, I as unpackFieldNames, ie as validateFieldValue, de as validationErrorToString, f as visualVariableFields };